module.exports = __webpack_public_path__ + "img/menu-mobile.c27739e8.svg";